import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../../../database/firebase'
import Select from 'react-select'
import { Line }  from 'react-chartjs-2';
import ClipLoader from "react-spinners/ClipLoader";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';
import Dialog from 'rc-dialog'

import { Chart, TimeScale, registerables } from 'chart.js';
Chart.register(...registerables);

const Styles = styled.div `


    // - - TOP DASHBOARD - - //

.topDashboard {
    margin-bottom: 11%;
    margin-top: 0%;
    padding-bottom: 4%;
}

.topDashboards:after {
    display: table;
    content: "";
    clear: both;
}

.topDashCol {
    float: left;
    text-align: center;
    width: 33.3%;
}

.topDashCard {
    width: 80%;
    height: 20vh;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    border-radius: 8px;
}

.topDashCard:after {
    content: "";
    clear: both;
    display: table;
}

.dashImg {
    float: left;
    text-align: center;
    width: 40%;
    height: 50%;
}

.dashLabel {
    float: left;
    text-align: left;
    width: 60%;
    height: 50%;
    margin-bottom: 7.5%;
}

    // - - TOP DASHBOARD IMG - - //

.imgContainer {
    margin-left: 20%;
    margin-top: 15%;
    width: 57.5%;
    height: 80%;
    background-color: #0930CB;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.imgContainer img {
    width: 50%;
}

    // - - TOP DASHBOARD LABEL - - //

.dashLabel h2 {
    font-family: Arvo;
    color: #0930CB;
    margin-bottom: 0px;
}

.dashLabel p {
    margin-top: 0px;
    font-family: Arvo;
    font-size: 13px;
    text-decoration: underline;
    color: #0930CB;
}

.dashLabel button {
    all: unset;
}

.activeMemberStyle {
    font-size: 20px;
    margin-bottom: 1.5%;
}

.selectMenu {
    width: 100%;
    // height: 10px;
}

.selectMenu2 {
    width: 90%;
    // height: 10px;
}

.selectMenu3 {
    width: 95%;
    // height: 10px;
    text-align: left;
    padding-top: 1%;
    margin-right: 5%;
}

.selectMenu4 {
    margin-left: 5%;
    width: 65%;
    margin-bottom: 1.5%;
}

.selectMenu5 {
    width: 85%;
}

    // - - DASHBOARD FIGURE - - //

.dashboardFigure h1 {
    padding-top: 10%;
    margin-left: 8%;
    padding-top: 5%;
    font-size: 30px;
}

.viewMoreInsightsBtn:hover {
    color: #0930cb;
    cursor: pointer;
}

    // - - QUICK INSIGHTS - - //

.quickInsightsHeader button {
    padding: 1%;
    width: 10%;
    background-color: ;
    color: white;
    font-family: gabarito;
    background-color: #D40C0C;
    border-radius: 7px;
    border: 2px solid #D40C0C;
    font-weight: bold;
    font-size: 90%;
    cursor: pointer;
}

    // - - ANALYTICS LOADING - - //

.analyticsLoading {
    text-align: center;
    margin-right: 6.5%;
    margin-top: 10.5%;
}

        //? - - - - - -- FOCUSED INSIGHTS - - - - - - ?//


    // - - ANALYTICS OPTIONS MENU - - //

.analyticsOptionsMenu {
    margin-top: 1%;
    width: 15%;
}

    // - - ANALYTICS GRAPH - - //

.analyticsGraph {
    border-radius: 8px;
    margin-top: 3.5%;
    height: 60vh;
    width: 88.25%;
    padding: 2.5%;
    padding-top: 0.5%;
    padding-bottom: 8.5%;
    border: 1px solid #0930cb;
    margin-bottom: 3%;
}

    // - - YEAR OPTIONS MEMU - - //

.yearOptionsMenu {
    margin-right: 6.5%;
    margin-top: 1%;
    width: 15%;
    margin-bottom: 0%;
}

    // - - REVENUE OPTIONS - - //

.revenueContainer {
    height: 30vh;
    width: 93.5%;
    background-color: #0930cb;
    margin-bottom: 1.5%;
    border-radius: 8px;
}

.revenueContainer:after {
    display: table;
    content: "";
    clear: both;
}

.revenueCol1 {
    float: left;
    width: 32.5%;
    text-align: center;
}

.revenueCol2 {
    float: left;
    width: 67.5%;
    text-align: center;
}

// .revenueCol3 {
//     float: left;
//     width: 23%;
//     text-align: center;
// }

// .revenueCol4 {
//     float: left;
//     width: 23%;
//     text-align: center;
// }

    // - GENERAL OPTIONS - //

.generalOptionsMenu {
    width: 82.5%;
    margin-left: 3.5%;
    margin-top: 2.5%;
    text-align: left;
}

    // - - DATA DISPLAY - - //

.dataDisplayLoading {
    padding-top: 11.25%;
}

.dataDisplay {
    overflow: scroll;
    height: 23.5vh;
    background-color: white;
    width: 97.5%;
    border-radius: 8px;
    margin-top: 1.5%;
}

.dataDisplayCell {
    pading: 2%;
    border-bottom: 1px solid #0930cb;
}


`

export default class Analytics extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showRevenueBtns: true,
            showViewMoreInsightsBtn: true,
            showFocusedInsights: true,
            showInsightsLoading: false,

            //* - - QUICK INSIGHTS - - *//

            showActiveMembersFigure: true,
            showActiveMembersFigureLoading: false,
            showTotalRevenueFigure: true,
            showTotalRevenueFigureLoading: false,
            showNewMembersFigure: true,
            showNewMembersFigureLoading: false,
            showTotalTransactionsFigure: true,
            showTotalTransactionsFigureLoading: false,

            totalMembers: 0,
            activeMembers: 0,
            newMembers: 0,

            totalRevenue: 0,
            totalTransactions: 0,

            currentMonthRevenueTotal: null,
            currentMonthTransactionsTotal: null,
            annualRevenueTotal: 0,

            showQuickInsightsHeader1: false,
            showBackToAllInsights: false,
            quickInsightsHeader1: "Members",
            quickInsightsHeader2: "Transactions",
            quickInsightsHeader3: "Points",
            quickInsightsHeader4: "Rewards",

            // - TOP RIGHT CARD - //
            showTopRightCardLoading: false,
            showTopRightCardRevenue: true,
            showTopRightCardMembers: false,

            //* - - FOCUSED INSIGHTS - - *//

            showChartHeader: true,
            showChart: true,
            showChartLoading: false,

            focusedSelectedCategory: "Revenue",
            currentYear: "",
            currentMonth: "",

            chartHeader: "Annual Revenue",
            currentChartLabel: "",
            currentChartLabels: [],
            currentData: [],
            annualChartLabels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            monthlyChartLabels: ['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
            weeklyChartLabels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],

            focusedPaneTimeframe: "Annual Revenue",
            focusedInsightsSelectedHeader: "",
            showCurrentRevenueTotal: true,
            showCurrentRevenueLoading: false,
            showDataDisplay: true,
            showDataDisplayLoading: false,

            annualRevenueData: [],
            highestSpending: [],
            highestEarning: [],
            mostOrdered: [],

            currentRevenueTotal: 0,

            janTotalRev: 0,
            febTotalRev: 0,
            marTotalRev: 0,
            aprTotalRev: 0,
            mayTotalRev: 0,
            junTotalRev: 0,
            julTotalRev: 0,
            augTotalRev: 0,
            sepTotalRev: 0,
            octTotalRev: 0,
            novTotalRev: 0,
            decTotalRev: 0,

            janChartData: [],
            febChartData: [],
            marChartData: [],
            aprChartData: [],
            mayChartData: [],
            junChartData: [],
            julChartData: [],
            augChartData: [],
            sepChartData: [],
            octChartData: [],
            novChartData: [],
            decChartData: []
        }
    }

    componentDidMount = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        this.setState({
            currentYear: currentYear
        })

            //* - - QUICK INSIGHTS DEFAULT CALLS - - *//
    
        this.getTotalMembers()
        this.getActiveMembers24Hours(currentYear)
        this.getTotalRevenue24Hours(currentYear)

            //* - - FOCUSED INSIGHTS DEFAULT CALLS - - *//

        setTimeout(() => {
            this.getCurrentYearTotalRevenue(currentYear)
        }, 500)
        
        this.getCurrentYearHighestSpendingCustomers(currentYear)
    }

            //* - - GET QUICK INSIGHTS DATA - - *//

        //! - ACTIVE MEMBERS - !//

    getTotalMembers = () => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("email_list")
        .get().then(snapshot => {
            this.setState({
                totalMembers: snapshot.size-1
            })
        })
    }

        //! - ACTIVE MEMBERS - !//

    getActiveMembers24Hours = (currentYear) => {

        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const dayString = dayOfMonth.toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("activity")
        .collection(dayString)
        .get().then(snapshot => {
            this.setState({
                activeMembers: snapshot.size
            })
        })

    }

    getActiveMembers1Week = () => {
        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate(); 

        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const sevenDaysAgoDayOfMonth = sevenDaysAgo.getDate();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];
        const previousMonth = monthAbbreviations[currentDate.getMonth() - 1];

        const currentYear = currentDate.getFullYear().toString();

        const promises = []

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        // Check if the current day is within the first week of the month
        let isFirstWeek = dayOfMonth <= 7;
    
        const startDay = isFirstWeek ? (sevenDaysAgoDayOfMonth > 1 ? sevenDaysAgoDayOfMonth : 1) : sevenDaysAgoDayOfMonth;

        const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
        
        for (let i = startDay; i <= (isFirstWeek ? Math.max(7, lastDayOfPreviousMonth) : dayOfMonth); i++) {

            const monthToQuery = isFirstWeek ? previousMonth : currentMonth;
            
            const weeklyCollectionPromise = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("admin")
            .doc("transactions")
            .collection("members")
            .doc(currentYear)
            .collection(monthToQuery)
            .doc("activity")
            .collection(`${i}`)
            .get().then(snapshot => {
                const currentTotal = snapshot.size || 0;
                updateTotal(currentTotal);
            })

            if (i === lastDayOfPreviousMonth) {
                isFirstWeek = false
                i = 0
            }
            promises.push(weeklyCollectionPromise)
        }
        
        Promise.all(promises)
        .then(() =>{
            this.setState({
                activeMembers: updatedTotal
            })
        })
    }

    getActiveMembers30Days = () => {

        const currentDate = new Date();
        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentYear = currentDate.getFullYear().toString();

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(currentYear)
        .collection(currentMonth)
        .get().then(snapshot => {
            this.setState({
                activeMembers: snapshot.size
            })
        })


    }

        //! - NEW MEMBERS - !//

    getNewMembers24Hours = () => {
        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const dayString = dayOfMonth.toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentYear = currentDate.getFullYear().toString();

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("registration")
        .collection(currentYear)
        .doc(currentMonth)
        .collection(dayString)
        .get().then(snapshot => {
            this.setState({
                newMembers: snapshot.size
            })
        })
    }

    getNewMembers1Week = () => {
        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate(); 

        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const sevenDaysAgoDayOfMonth = sevenDaysAgo.getDate();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];
        const previousMonth = monthAbbreviations[currentDate.getMonth() - 1];

        const currentYear = currentDate.getFullYear().toString();

        const promises = []

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        let isFirstWeek = dayOfMonth <= 7;
    
        const startDay = isFirstWeek ? (sevenDaysAgoDayOfMonth > 1 ? sevenDaysAgoDayOfMonth : 1) : sevenDaysAgoDayOfMonth;
        console.log(`START DAY: ${startDay}`)

        const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();

        for (let i = startDay; i <= (isFirstWeek ? Math.max(7, lastDayOfPreviousMonth) : dayOfMonth); i++) {
        
            const monthToQuery = isFirstWeek ? previousMonth : currentMonth;

            const weeklyCollectionPromise = fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("registration")
            .collection(currentYear)
            .doc(monthToQuery)
            .collection(`${i}`)
            .get().then(snapshot => {
                const currentTotal = snapshot.size || 0;
                updateTotal(currentTotal);
            })

            if (i === lastDayOfPreviousMonth) {
                isFirstWeek = false
                i = 0
            }
            promises.push(weeklyCollectionPromise)
        }

        Promise.all(promises)
        .then(() =>{
            this.setState({
                newMembers: updatedTotal
            })
        })
    }

    getNewMembers30Days = () => {
        const currentDate = new Date();
        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentYear = currentDate.getFullYear().toString();

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("registration")
        .collection(currentYear)
        .doc(currentMonth)
        .collection("0monthlyUsers")
        .get().then(snapshot => {
            this.setState({
                newMembers: snapshot.size
            })
        })
    }

        //! - TOTAL REVENUE - !//

    getTotalRevenue24Hours = (currentYear) => {

        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const dayString = dayOfMonth.toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("byItem")
        .collection(dayString)
        .doc("0total")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    totalRevenue: doc.data().total
                })
            } else {
                this.setState({
                    totalRevenue: 0
                })
            }
        })
    }

    getTotalRevenue1Week = () => {
        const currentDate = new Date()
        const dayOfMonth = currentDate.getDate();

        console.log(`DAY OF MONTH: ${dayOfMonth}`)
    
        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const sevenDaysAgoDayOfMonth = sevenDaysAgo.getDate();

        console.log(`SEVEN DAYS AGO: ${sevenDaysAgoDayOfMonth}`)
    
        const monthAbbreviations = [
            'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
        ];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];
        const previousMonth = monthAbbreviations[currentDate.getMonth() - 1];
    
        const currentYear = currentDate.getFullYear().toString();
    
        const promises = [];
        let updatedTotal = 0;
    
        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };
    
        // Check if the current day is within the first week of the month
        let isFirstWeek = dayOfMonth <= 7;
    
        const startDay = isFirstWeek ? (sevenDaysAgoDayOfMonth > 1 ? sevenDaysAgoDayOfMonth : 1) : sevenDaysAgoDayOfMonth;

        const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
        // let i = startDay
        
        for (let i = startDay; i <= (isFirstWeek ? Math.max(7, lastDayOfPreviousMonth) : dayOfMonth); i++) {

            const monthToQuery = isFirstWeek ? previousMonth : currentMonth;
    
            const weeklyCollectionRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(currentYear)
                .collection(monthToQuery)
                .doc("byItem")
                .collection(`${i}`)
                .doc("0total");

                console.log(`LOOP ITERATIONS : ${i}`)
    
            const weeklyCollectionPromise = weeklyCollectionRef.get().then(doc => {
                if (doc.exists) {
                    const currentTotal = doc.data().total || 0;
                    updateTotal(currentTotal);
                }
            });
            
            if (i === lastDayOfPreviousMonth) {
                isFirstWeek = false
                i = 0
            }

            promises.push(weeklyCollectionPromise);

        }
    
        Promise.all(promises)
            .then(() => {
                this.setState({
                    totalRevenue: updatedTotal
                });
            });
    }

    getTotalRevenue1Month = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    currentMonthRevenueTotal: doc.data().total,
                    totalRevenue: doc.data().total || 0,
                })
            }
        })

    }

    getTotalRevenue3Months = () => {

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentMonthIndex = currentDate.getMonth();
        // Specify how many months before the current month you want
        const monthsBefore = 3;

        // Calculate the index of the target month
        const targetMonthIndex = (currentMonthIndex - monthsBefore + 12) % 12;

        // Get the abbreviated name of the target month
        const targetMonth = monthAbbreviations[targetMonthIndex];
        const targetMonthPlus1 = monthAbbreviations[targetMonthIndex + 1];
        const targetMonthPlus2 = monthAbbreviations[targetMonthIndex + 2];

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        const promises = []

        const month3AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonth)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month3AwayCollectionPromise)

        const month2AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus1)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month2AwayCollectionPromise)

        const month1AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus2)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            } 
        })

        promises.push(month1AwayCollectionPromise)

        Promise.all(promises)
        .then(async() => {
            if (this.state.currentMonthRevenueTotal !== null) {
                this.setState({
                    totalRevenue: updatedTotal+this.state.currentMonthRevenueTotal
                })
            } else {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("revenue")
                .doc(currentYear)
                .collection(currentMonth)
                .doc("total")
                .get().then(doc => {
                    let currentTotal
                    if (doc.exists) {
                        currentTotal = doc.data().total || 0;
                        this.setState({
                            totalRevenue: updatedTotal + currentTotal
                        })
                    } else {
                        this.setState({
                            totalRevenue: updatedTotal
                        })
                    }
                })
            }
        })
        
    }

    getTotalRevenue6Months = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentMonthIndex = currentDate.getMonth();
        // Specify how many months before the current month you want
        const monthsBefore = 6;

        // Calculate the index of the target month
        const targetMonthIndex = (currentMonthIndex - monthsBefore + 12) % 12;

        // Get the abbreviated name of the target month
        const targetMonth = monthAbbreviations[targetMonthIndex];
        const targetMonthPlus1 = monthAbbreviations[targetMonthIndex + 1];
        const targetMonthPlus2 = monthAbbreviations[targetMonthIndex + 2];
        const targetMonthPlus3 = monthAbbreviations[targetMonthIndex + 3];
        const targetMonthPlus4 = monthAbbreviations[targetMonthIndex + 4];
        const targetMonthPlus5 = monthAbbreviations[targetMonthIndex + 5];

        let updatedTotal = 0

        const updateTotal = (currentTotal) => {
            updatedTotal += currentTotal;
        };

        const promises = []

        const month6AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonth)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month6AwayCollectionPromise)

        const month5AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus1)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month5AwayCollectionPromise)

        const month4AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus2)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month4AwayCollectionPromise)

        const month3AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus3)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month3AwayCollectionPromise)

        const month2AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus4)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month2AwayCollectionPromise)

        const month1AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(currentYear)
        .collection(targetMonthPlus5)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                const currentTotal = doc.data().total || 0;
                updateTotal(currentTotal)
            }
        })

        promises.push(month1AwayCollectionPromise)

        Promise.all(promises)
        .then(async() => {
            if (this.state.currentMonthRevenueTotal !== null) {
                this.setState({
                    totalRevenue: updatedTotal+this.state.currentMonthRevenueTotal
                })
            } else {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("revenue")
                .doc(currentYear)
                .collection(currentMonth)
                .doc("total")
                .get().then(doc => {
                    if (doc.exists) {
                        const currentTotal = doc.data().total || 0;
                        this.setState({
                            totalRevenue: updatedTotal + currentTotal
                        })
                    } else {
                        this.setState({
                            totalRevenue: updatedTotal
                        })
                    }
                })
            }
        })
    }

        //! - TOTAL TRANSACTIONS - !//

    getTotalTransactions24Hours = () => {
        const currentDate = new Date();
        const dayOfMonth = currentDate.getDate();
        const dayString = dayOfMonth.toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentYear = currentDate.getFullYear().toString();

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("byItem")
        .collection(dayString)
        .doc("0qty")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    totalTransactions: doc.data().qty
                })
            } else {
                this.setState({
                    totalTransactions: 0
                })
            }
            
        })
    }

    getTotalTransactions1Week = () => {
        const currentDate = new Date()
        const dayOfMonth = currentDate.getDate();
    
        const sevenDaysAgo = new Date(currentDate);
        sevenDaysAgo.setDate(currentDate.getDate() - 7);
        const sevenDaysAgoDayOfMonth = sevenDaysAgo.getDate();
    
        const monthAbbreviations = [
            'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'
        ];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];
        const previousMonth = monthAbbreviations[currentDate.getMonth() - 1];
    
        const currentYear = currentDate.getFullYear().toString();
    
        const promises = [];
        let updatedQuantity = 0;
    
        const updateQuantity = (currentQuantity) => {
            updatedQuantity += currentQuantity;
        };
    
        // Check if the current day is within the first week of the month
        let isFirstWeek = dayOfMonth <= 7;
    
        const startDay = isFirstWeek ? (sevenDaysAgoDayOfMonth > 1 ? sevenDaysAgoDayOfMonth : 1) : sevenDaysAgoDayOfMonth;

        const lastDayOfPreviousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
        // let i = startDay
        
        for (let i = startDay; i <= (isFirstWeek ? Math.max(7, lastDayOfPreviousMonth) : dayOfMonth); i++) {

            const monthToQuery = isFirstWeek ? previousMonth : currentMonth;
    
            const weeklyCollectionRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(currentYear)
                .collection(monthToQuery)
                .doc("byItem")
                .collection(`${i}`)
                .doc("0qty");
    
            const weeklyCollectionPromise = weeklyCollectionRef.get().then(doc => {
                if (doc.exists) {
                    const currentQuantity = doc.data().qty || 0;
                    updateQuantity(currentQuantity);
                }
            });
            
            if (i === lastDayOfPreviousMonth) {
                isFirstWeek = false
                i = 0
            }

            promises.push(weeklyCollectionPromise);

        }
    
        Promise.all(promises)
        .then(() => {
            this.setState({
                totalRevenue: updatedQuantity
            });
        });
    }

    getTotalTransactions1Month = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(currentMonth)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    currentMonthTransactionsTotal: doc.data().qty,
                    totalTransactions: doc.data().qty || 0
                })
            }
        })
    }

    getTotalTransactions3Months = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentMonthIndex = currentDate.getMonth();
        // Specify how many months before the current month you want
        const monthsBefore = 3;

        // Calculate the index of the target month
        const targetMonthIndex = (currentMonthIndex - monthsBefore + 12) % 12;

        // Get the abbreviated name of the target month
        const targetMonth = monthAbbreviations[targetMonthIndex];
        const targetMonthPlus1 = monthAbbreviations[targetMonthIndex + 1];
        const targetMonthPlus2 = monthAbbreviations[targetMonthIndex + 2];

        console.log(targetMonth)
        console.log(targetMonthPlus1)
        console.log(targetMonthPlus2)

        let updatedQuantity = 0

        const updateQuantity = (currentQuantity) => {
            updatedQuantity += currentQuantity;
        };

        const promises = []

        const month3AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonth)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month3AwayCollectionPromise)

        const month2AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus1)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month2AwayCollectionPromise)

        const month1AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus2)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                console.log(doc.data().qty)
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month1AwayCollectionPromise)

        Promise.all(promises)
        .then(async() => {
            if (this.state.currentMonthTransactionsTotal !== null) {
                this.setState({
                    totalTransactions: updatedQuantity+this.state.currentMonthTransactionsTotal
                })
            } else {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(currentYear)
                .collection(currentMonth)
                .doc("qty")
                .get().then(doc => {
                    if (doc.exists) {
                        const currentQuantity = doc.data().qty || 0;
                        this.setState({
                            totalTransactions: updatedQuantity + currentQuantity
                        })
                    } else {
                        this.setState({
                            totalTransactions: updatedQuantity
                        })
                    }
                })
            }
        })
    }

    getTotalTransactions6Months = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const currentMonthIndex = currentDate.getMonth();
        // Specify how many months before the current month you want
        const monthsBefore = 6;

        // Calculate the index of the target month
        const targetMonthIndex = (currentMonthIndex - monthsBefore + 12) % 12;

        // Get the abbreviated name of the target month
        const targetMonth = monthAbbreviations[targetMonthIndex];
        const targetMonthPlus1 = monthAbbreviations[targetMonthIndex + 1];
        const targetMonthPlus2 = monthAbbreviations[targetMonthIndex + 2];
        const targetMonthPlus3 = monthAbbreviations[targetMonthIndex + 3];
        const targetMonthPlus4 = monthAbbreviations[targetMonthIndex + 4];
        const targetMonthPlus5 = monthAbbreviations[targetMonthIndex + 5];

        let updatedQuantity = 0

        const updateQuantity = (currentQuantity) => {
            updatedQuantity += currentQuantity
        };

        const promises = []

        const month6AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonth)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month6AwayCollectionPromise)

        const month5AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus1)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month5AwayCollectionPromise)

        const month4AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus2)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month4AwayCollectionPromise)

        const month3AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus3)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month3AwayCollectionPromise)

        const month2AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus4)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month2AwayCollectionPromise)

        const month1AwayCollectionPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(currentYear)
        .collection(targetMonthPlus5)
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(month1AwayCollectionPromise)

        Promise.all(promises)
        .then(async() => {
            if (this.state.currentMonthTransactionsTotal !== null) {
                this.setState({
                    totalTransactions: updatedQuantity+this.state.currentMonthTransactionsTotal
                })
            } else {
                await fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(currentYear)
                .collection(currentMonth)
                .doc("qty")
                .get().then(doc => {
                    if(doc.exists) {
                        const currentQuantity = doc.data().qty || 0;
                        this.setState({
                            totalTransactions: updatedQuantity + currentQuantity
                        })
                    } else {
                        this.setState({
                            totalTransactions: updatedQuantity
                        })
                    }
                })
            }
        })
    }

        //* - - QUICK INSIGHTS DROPDOWN HANDLERS - - *//

    handleActiveMembersChanged = (selectedOptions) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        if (selectedOptions.value === '1-day') {
            this.getActiveMembers24Hours(currentYear)
        } else if (selectedOptions.value === "7-days") {
            this.getActiveMembers1Week()
        } else if (selectedOptions.value === "30-days") {
            this.getActiveMembers30Days()
        }
        this.setState({
            showActiveMembersFigure: false,
            showActiveMembersFigureLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showActiveMembersFigureLoading: false,
                    showActiveMembersFigure: true,
                })
            }, 2000)
        })
    }

    handleTotalRevenueChanged = async (selectedOptions) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();
        if (selectedOptions.value === "1-day") {
            this.getTotalRevenue24Hours(currentYear)
        } else if (selectedOptions.value === "7-days") {
            this.getTotalRevenue1Week()
        } else if (selectedOptions.value === "1-month") {
            this.getTotalRevenue1Month()
        } else if (selectedOptions.value === "3-months") {
            this.getTotalRevenue3Months()
        } else if (selectedOptions.value === "6-months") {
            this.getTotalRevenue6Months()
        } else if (selectedOptions.value === "1-year") {
            await this.getCurrentYearTotalRevenue(currentYear)
            this.setState({totalRevenue: this.state.annualRevenueTotal})
        }
        this.setState({
            showTotalRevenueFigure: false,
            showTotalRevenueFigureLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTotalRevenueFigureLoading: false,
                    showTotalRevenueFigure: true,
                })
            }, 2000)
        })
    }

    handleNewMembersChanged = (selectedOptions) => {
        if (selectedOptions.value === "1-day") {
            this.getNewMembers24Hours()
        } else if (selectedOptions.value === "7-days") {
            this.getNewMembers1Week()
        } else if (selectedOptions.value === "30-days") {
            this.getNewMembers30Days()
        }
        this.setState({
            showNewMembersFigure: false,
            showNewMembersFigureLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showNewMembersFigureLoading: false,
                    showNewMembersFigure: true,
                })
            }, 2000)
        })
    }

    handleTotalTransactionsChanged = (selectedOptions) => {

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        if (selectedOptions.value === "1-day") {
            this.getTotalTransactions24Hours()
        } else if (selectedOptions.value === "7-days") {
            this.getTotalTransactions1Week()
        } else if (selectedOptions.value === "1-month") {
            this.getTotalTransactions1Month()
        } else if (selectedOptions.value === "3-months") {
            this.getTotalTransactions3Months()
        } else if (selectedOptions.value === "6-months") {
            this.getTotalTransactions6Months()
        } else if (selectedOptions.value === "1-year") {
            this.getCurrentYearTotalTransactions(currentYear)
        }
        this.setState({
            showTotalTransactionsFigure: false,
            showTotalTransactionsFigureLoading: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    showTotalTransactionsFigureLoading: false,
                    showTotalTransactionsFigure: true,
                })
            }, 2000)
        })
    }

        //* - - GET ANNUAL DATA - - //

    getCurrentYearTotalRevenue = (year) => {
        this.setState({
            currentChartLabel: "Monthly Revenue (KES)",
            currentChartLabels: [],
            currentData: []
        })

        let revenueArray = []

        const promises = []
        
        const janRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("jan")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(janRevPromise)

        const febRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("feb")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(febRevPromise)

        const marRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("mar")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(marRevPromise)

        const aprRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("apr")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(aprRevPromise)

        const mayRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("may")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(mayRevPromise)

        const junRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("jun")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(junRevPromise)

        const julRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("jul")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(julRevPromise)

        const augRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("aug")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(augRevPromise)

        const sepRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("sep")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(sepRevPromise)

        const octRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("oct")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(octRevPromise)

        const novRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("nov")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(novRevPromise)

        const decRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(year)
        .collection("dec")
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                revenueArray.push(doc.data().total || 0)
            } else {
                revenueArray.push(0)
            }
        })

        promises.push(decRevPromise)

        Promise.all(promises)
        .then(() => {
            console.log(revenueArray)
            const total = revenueArray.reduce((acc, value) => acc + value, 0)
            this.setState(() => ({
                currentData: revenueArray,
                currentChartLabels: this.state.annualChartLabels,
                currentRevenueTotal: total,
                annualRevenueTotal: total,
                annualRevenueData: revenueArray,
            }));
        })
    }

    getCurrentYearTotalTransactions = (year) => {

        let updatedQuantity = 0

        const updateQuantity = (currentQuantity) => {
            updatedQuantity += currentQuantity;
        };

        const promises = []

        const janRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("jan")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(janRevPromise)

        const febRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("feb")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(febRevPromise)

        const marRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("mar")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(marRevPromise)

        const aprRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("apr")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(aprRevPromise)

        const mayRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("may")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(mayRevPromise)

        const junRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("jun")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(junRevPromise)

        const julRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("jul")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(julRevPromise)

        const augRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("aug")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(augRevPromise)

        const sepRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("sep")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(sepRevPromise)

        const octRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("oct")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(octRevPromise)

        const novRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("nov")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(novRevPromise)

        const decRevPromise = fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("dec")
        .doc("qty")
        .get().then(doc => {
            if (doc.exists) {
                const currentQuantity = doc.data().qty || 0;
                updateQuantity(currentQuantity)
            }
        })

        promises.push(decRevPromise)

        Promise.all(promises)
        .then(() => {
            this.setState(() => ({
                totalTransactions: updatedQuantity,
                annualTransactionsTotal: updatedQuantity,
            }));
        })

    }

    getCurrentYearHighestSpendingCustomers = async (year) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class User {
            constructor(id, name, qty, total) {
                this.id = id
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.name, data.qty, data.total)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            this.setState({
                currentChartLabel: "Monthly Revenue (KES)",
                currentData: this.state.annualRevenueData,
                currentChartLabels: this.state.annualChartLabels,
                showRenderHighestSpendingRevenue: true,
                focusedInsightsSelectedHeader: "Highest Spending Customers:",
                highestSpending: sortedArray
            })
        })
    }

    getCurrentYearMostFrequentCustomers = async (year) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class User {
            constructor(id, name, qty, total) {
                this.id = id
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.name, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(year)
        .collection("allOrders")
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            this.setState({
                currentChartLabel: "Monthly Revenue (KES)",
                currentData: this.state.annualRevenueData,
                currentChartLabels: this.state.annualChartLabels,
                showRenderHighestSpendingRevenue: true,
                focusedInsightsSelectedHeader: "Most Frequent Customers:",
                highestSpending: sortedArray
            })
        })
    }

    getCurrentYearMostOrdered = async (year) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuItem {
            constructor(item, qty, total) {
                this.item = item
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.item + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuItemConverter = {
            toFirestore : function(item) {
                return {
                    item: item.item,
                    qty: item.qty,
                    total: item.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuItem(data.item, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("allOrders")
        .withConverter(menuItemConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            sortedArray.map(item => {
                this.state.currentChartLabels.push(item.item)
                this.state.currentData.push(item.total)
            })
            // const mostOrdered = sortedArray.slice(0, 10);
            this.setState({
                currentChartLabel: "Item Revenue (KES)",
                showRenderMostOrderedRevenue: true,
                showRenderHighestSpendingRevenue: false,
                mostOrdered: sortedArray
            })
        })
    }

    getCurrentYearMostOrderedCategory = async (year) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuCategory {
            constructor(category, qty, total) {
                this.category = category
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.category + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuCategoryConverter = {
            toFirestore : function(category) {
                return {
                    category: category.category,
                    qty: category.qty,
                    total: category.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuCategory(data.category, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("allCategories")
        .withConverter(menuCategoryConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            sortedArray.map(category => {
                if (category.category === "coffee_and_tea") {
                    category.category = "Coffee and Tea"
                } else if (category.category === "iced_coffee_and_tea") {
                    category.category = "Iced Coffee and Tea"
                } else if (category.category === "breakfast") {
                    category.category = "Breakfast"
                } else if (category.category === "starters_and_sharing") {
                    category.category = "Starters and Sharing"
                } else if (category.category === "lunch_and_dinner") {
                    category.category = "Lunch and Dinner"
                } else if (category.category === "burgers") {
                    category.category = "Burgers"
                } else if (category.category === "chips") {
                    category.category = "Chips"
                } else if (category.category === "wings") {
                    category.category = "Wings"
                } else if (category.category === "sandwiches") {
                    category.category = "Sandwiches"
                } else if (category.category === "salads") {
                    category.category = "Salads"
                } else if (category.category === "art_pizzas") {
                    category.category = "Art Pizzas"
                } else if (category.category === "pasta") {
                    category.category = "Pasta"
                } else if (category.category === "bakery") {
                    category.category = "Bakery"
                } else if (category.category === "cakes_and_desserts") {
                    category.category = "Cakes and Desserts"
                } else if (category.category === "cold_press_juices") {
                    category.category = "Cold Press Juices"
                } else if (category.category === "soft_drinks") {
                    category.category = "Soft Drinks"
                } else if (category.category === "kids_menu") {
                    category.category = "Kids Menu"
                } else if (category.category === "whole_cakes") {
                    category.category = "Whole Cakes"
                } else if (category.category === "power_smoothies") {
                    category.category = "Power Smoothies"
                } else if (category.category === "steaks") {
                    category.category = "Steaks"
                } else if (category.category === "soup") {
                    category.category = "Soup"
                } else if (category.category === "mocktails") {
                    category.category = "Mocktails"
                } else if (category.category === "hot_n_boozy") {
                    category.category = "Hot N Boozy"
                } else if (category.category === "beer") {
                    category.category = "Beer"
                } else if (category.category === "white_wine") {
                    category.category = "White Wine"
                } else if (category.category === "sangria") {
                    category.category = "Sangria"
                } else if (category.category === "red_wine") {
                    category.category = "Red Wine"
                } else if (category.category === "sparkling") {
                    category.category = "Sparkling"
                } else if (category.category === "rose") {
                    category.category = "Rosé"
                } else if (category.category === "art_cocktails") {
                    category.category = "Art Cocktails"
                } else if (category.category === "cocktails") {
                    category.category = "Cocktails"
                } else if (category.category === "spirits_and_liquer") {
                    category.category = "Spirits and Liquer"
                } else if (category.category === "milkshakes") {
                    category.category = "Milkshakes"
                } else if (category.category === "quiches") {
                    category.category = "Quiches"
                }
                this.state.currentChartLabels.push(category.category)
                this.state.currentData.push(category.total)
            })
            this.setState({
                currentChartLabel: "Category Revenue (KES)",
                mostOrdered: sortedArray
            })
        })
    }

    getCurrentYearHighestEarning = async (year) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuItem {
            constructor(item, qty, total) {
                this.item = item
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.item + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuItemConverter = {
            toFirestore : function(item) {
                return {
                    item: item.item,
                    qty: item.qty,
                    total: item.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuItem(data.item, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("allOrders")
        .withConverter(menuItemConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            sortedArray.map(item => {
                this.state.currentChartLabels.push(item.item)
                this.state.currentData.push(item.total)
            })
            console.log(sortedArray)
            // const mostOrdered = sortedArray.slice(0, 10);
            this.setState({
                currentChartLabel: "Item Revenue (KES)",
                showRenderHighestEarningRevenue: true,
                highestEarning: sortedArray
            })
        })
    }

    getCurrentYearHighestEarningCategory = async (year) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuCategory {
            constructor(category, qty, total) {
                this.category = category
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.category + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuCategoryConverter = {
            toFirestore : function(category) {
                return {
                    category: category.category,
                    qty: category.qty,
                    total: category.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuCategory(data.category, data.qty, data.total)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(year)
        .collection("allCategories")
        .withConverter(menuCategoryConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            sortedArray.map(category => {
                if (category.category === "coffee_and_tea") {
                    category.category = "Coffee and Tea"
                } else if (category.category === "iced_coffee_and_tea") {
                    category.category = "Iced Coffee and Tea"
                } else if (category.category === "breakfast") {
                    category.category = "Breakfast"
                } else if (category.category === "starters_and_sharing") {
                    category.category = "Starters and Sharing"
                } else if (category.category === "lunch_and_dinner") {
                    category.category = "Lunch and Dinner"
                } else if (category.category === "burgers") {
                    category.category = "Burgers"
                } else if (category.category === "chips") {
                    category.category = "Chips"
                } else if (category.category === "wings") {
                    category.category = "Wings"
                } else if (category.category === "sandwiches") {
                    category.category = "Sandwiches"
                } else if (category.category === "salads") {
                    category.category = "Salads"
                } else if (category.category === "art_pizzas") {
                    category.category = "Art Pizzas"
                } else if (category.category === "pasta") {
                    category.category = "Pasta"
                } else if (category.category === "bakery") {
                    category.category = "Bakery"
                } else if (category.category === "cakes_and_desserts") {
                    category.category = "Cakes and Desserts"
                } else if (category.category === "cold_press_juices") {
                    category.category = "Cold Press Juices"
                } else if (category.category === "soft_drinks") {
                    category.category = "Soft Drinks"
                } else if (category.category === "kids_menu") {
                    category.category = "Kids Menu"
                } else if (category.category === "whole_cakes") {
                    category.category = "Whole Cakes"
                } else if (category.category === "power_smoothies") {
                    category.category = "Power Smoothies"
                } else if (category.category === "steaks") {
                    category.category = "Steaks"
                } else if (category.category === "soup") {
                    category.category = "Soup"
                } else if (category.category === "mocktails") {
                    category.category = "Mocktails"
                } else if (category.category === "hot_n_boozy") {
                    category.category = "Hot N Boozy"
                } else if (category.category === "beer") {
                    category.category = "Beer"
                } else if (category.category === "white_wine") {
                    category.category = "White Wine"
                } else if (category.category === "sangria") {
                    category.category = "Sangria"
                } else if (category.category === "red_wine") {
                    category.category = "Red Wine"
                } else if (category.category === "sparkling") {
                    category.category = "Sparkling"
                } else if (category.category === "rose") {
                    category.category = "Rosé"
                } else if (category.category === "art_cocktails") {
                    category.category = "Art Cocktails"
                } else if (category.category === "cocktails") {
                    category.category = "Cocktails"
                } else if (category.category === "spirits_and_liquer") {
                    category.category = "Spirits and Liquer"
                } else if (category.category === "milkshakes") {
                    category.category = "Milkshakes"
                } else if (category.category === "quiches") {
                    category.category = "Quiches"
                }
                this.state.currentChartLabels.push(category.category)
                this.state.currentData.push(category.total)
            })
            this.setState({
                currentChartLabel: "Category Revenue (KES)",
                // showRenderHighestSpendingRevenue: true,
                highestEarning: sortedArray
            })
        })
    }

        //* - - GET MONTHLY DATA - - *//

    getMonthlyRevenueTotal = (month) => {
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("revenue")
        .doc(this.state.currentYear)
        .collection(month)
        .doc("total")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    currentRevenueTotal: doc.data().total
                })
            } else {
                this.setState({
                    currentRevenueTotal: 0
                })
            }
        })
    }

    getMonthlyChartData = async (month) => {
        let monthlyRevenue = []

        const promises = []

        this.setState({
            currentChartLabels: [],
            currentData: [],
            showChart: false,
            showChartLoading: true
        })

        if (month === "jan" && this.state.janChartData.length !== 0) {
           this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.janChartData,
                showChartLoading: false,
                showChart: true
           })
        } else if (month === "feb" && this.state.febChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.febChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "mar" && this.state.marChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.marChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "apr" && this.state.aprChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.aprChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "may" && this.state.mayChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.mayChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "jun" && this.state.junChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.junChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "jul" && this.state.julChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.julChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "aug" && this.state.augChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.augChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "sep" && this.state.sepChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.sepChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "oct" && this.state.octChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.octChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "nov" && this.state.novChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.novChartData,
                showChartLoading: false,
                showChart: true
            })
        } else if (month === "dec" && this.state.decChartData.length !== 0) {
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: this.state.decChartData,
                showChartLoading: false,
                showChart: true
            })
        } else {
            for (let i = 1; i < 32; i++) {
                const dailyCollectionRef = fire.firestore().collection("clients")
                .doc("artcaffe")
                .collection("admin")
                .doc("transactions")
                .collection("orders")
                .doc(this.state.currentYear)
                .collection(month)
                .doc("byItem")
                .collection(`${i}`)
                .doc('0total')
                
                const dailyCollectionPromise = await dailyCollectionRef.get().then(doc => {
                    if (doc.exists) {
                        monthlyRevenue.push(doc.data().total)
                    } else {
                        monthlyRevenue.push(0)
                    }
                })
                promises.push(dailyCollectionPromise)
            }
    
            await Promise.all(promises);
    
            if (month === "jan") {
                this.setState({janChartData: monthlyRevenue})
            } else if (month === "feb") {
                this.setState({febChartData: monthlyRevenue})
            } else if (month === "mar") {
                this.setState({marChartData: monthlyRevenue})
            } else if (month === "apr") {
                this.setState({aprChartData: monthlyRevenue})
            } else if (month === "may") {
                this.setState({mayChartData: monthlyRevenue})
            } else if (month === "jun") {
                this.setState({junChartData: monthlyRevenue})
            } else if (month === "jul") {
                this.setState({julChartData: monthlyRevenue})
            } else if (month === "aug") {
                this.setState({augChartData: monthlyRevenue})
            } else if (month === "sep") {
                this.setState({sepChartData: monthlyRevenue})
            } else if (month === "oct") {
                this.setState({octChartData: monthlyRevenue})
            } else if (month === "nov") {
                this.setState({novChartData: monthlyRevenue})
            } else if (month === "dec") {
                this.setState({decChartData: monthlyRevenue})
            }
            this.setState({
                currentChartLabels: this.state.monthlyChartLabels,
                currentChartLabel: "Daily Revenue (KES)",
                currentData: monthlyRevenue,
                showChartLoading: false,
                showChart: true
            })
        }
    }

    getCurrentMonthHighestSpendingCustomers = async (month) => {
        // this.setState({
        //     currentChartLabels: [],
        //     currentData: []
        // })
        class User {
            constructor(id, name, qty, total) {
                this.id = id
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.name, data.qty, data.total)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(this.state.currentYear)
        .collection(month)
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            // const removedItem = sortedArray.shift()
            this.setState({
                showRenderHighestSpendingRevenue: true,
                focusedInsightsSelectedHeader: "Highest Spending Customers:",
                highestSpending: sortedArray
            })
        })
    }

    getCurrentMonthMostFrequentCustomers = async (month) => {
        // this.setState({
        //     currentChartLabels: [],
        //     currentData: []
        // })
        class User {
            constructor(id, name, qty, total) {
                this.id = id
                this.name = name
                this.qty = qty
                this.total = total 
            }
            toString () {
                return this.id + ', ' +
                this.name + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var userConverter = {
            toFirestore : function(user) {
                return {
                    id: user.id,
                    name: user.name,
                    qty: user.qty,
                    total: user.total,
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new User(data.id, data.name, data.qty, data.total)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("members")
        .doc(this.state.currentYear)
        .collection(month)
        .withConverter(userConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            // const removedItem = sortedArray.shift()
            this.setState({
                showRenderHighestSpendingRevenue: true,
                focusedInsightsSelectedHeader: "Most Frequent Customers:",
                highestSpending: sortedArray
            })
        })
    }

    getCurrentMonthMostOrdered = async (month) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuItem {
            constructor(item, qty, total) {
                this.item = item
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.item + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuItemConverter = {
            toFirestore : function(item) {
                return {
                    item: item.item,
                    qty: item.qty,
                    total: item.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuItem(data.item, data.qty, data.total)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(this.state.currentYear)
        .collection(month)
        .doc("allOrders")
        .collection("list")
        .withConverter(menuItemConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            sortedArray.map(item => {
                this.state.currentChartLabels.push(item.item)
                this.state.currentData.push(item.total)
            })
            // const mostOrdered = sortedArray.slice(0, 10);
            this.setState({
                currentChartLabel: "Item Revenue (KES)",
                showRenderMostOrderedRevenue: true,
                showRenderHighestSpendingRevenue: false,
                mostOrdered: sortedArray
            })
        })
    }

    getCurrentMonthMostOrderedCategory = async (month) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuCategory {
            constructor(category, qty, total) {
                this.category = category
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.category + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuCategoryConverter = {
            toFirestore : function(category) {
                return {
                    category: category.category,
                    qty: category.qty,
                    total: category.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuCategory(data.category, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(this.state.currentYear)
        .collection(month)
        .doc("allCategories")
        .collection("list")
        .withConverter(menuCategoryConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.qty - a.qty)
            sortedArray.map(category => {
                if (category.category === "coffee_and_tea") {
                    category.category = "Coffee and Tea"
                } else if (category.category === "iced_coffee_and_tea") {
                    category.category = "Iced Coffee and Tea"
                } else if (category.category === "breakfast") {
                    category.category = "Breakfast"
                } else if (category.category === "starters_and_sharing") {
                    category.category = "Starters and Sharing"
                } else if (category.category === "lunch_and_dinner") {
                    category.category = "Lunch and Dinner"
                } else if (category.category === "burgers") {
                    category.category = "Burgers"
                } else if (category.category === "chips") {
                    category.category = "Chips"
                } else if (category.category === "wings") {
                    category.category = "Wings"
                } else if (category.category === "sandwiches") {
                    category.category = "Sandwiches"
                } else if (category.category === "salads") {
                    category.category = "Salads"
                } else if (category.category === "art_pizzas") {
                    category.category = "Art Pizzas"
                } else if (category.category === "pasta") {
                    category.category = "Pasta"
                } else if (category.category === "bakery") {
                    category.category = "Bakery"
                } else if (category.category === "cakes_and_desserts") {
                    category.category = "Cakes and Desserts"
                } else if (category.category === "cold_press_juices") {
                    category.category = "Cold Press Juices"
                } else if (category.category === "soft_drinks") {
                    category.category = "Soft Drinks"
                } else if (category.category === "kids_menu") {
                    category.category = "Kids Menu"
                } else if (category.category === "whole_cakes") {
                    category.category = "Whole Cakes"
                } else if (category.category === "power_smoothies") {
                    category.category = "Power Smoothies"
                } else if (category.category === "steaks") {
                    category.category = "Steaks"
                } else if (category.category === "soup") {
                    category.category = "Soup"
                } else if (category.category === "mocktails") {
                    category.category = "Mocktails"
                } else if (category.category === "hot_n_boozy") {
                    category.category = "Hot N Boozy"
                } else if (category.category === "beer") {
                    category.category = "Beer"
                } else if (category.category === "white_wine") {
                    category.category = "White Wine"
                } else if (category.category === "sangria") {
                    category.category = "Sangria"
                } else if (category.category === "red_wine") {
                    category.category = "Red Wine"
                } else if (category.category === "sparkling") {
                    category.category = "Sparkling"
                } else if (category.category === "rose") {
                    category.category = "Rosé"
                } else if (category.category === "art_cocktails") {
                    category.category = "Art Cocktails"
                } else if (category.category === "cocktails") {
                    category.category = "Cocktails"
                } else if (category.category === "spirits_and_liquer") {
                    category.category = "Spirits and Liquer"
                } else if (category.category === "milkshakes") {
                    category.category = "Milkshakes"
                } else if (category.category === "quiches") {
                    category.category = "Quiches"
                }
                this.state.currentChartLabels.push(category.category)
                this.state.currentData.push(category.total)
            })
            this.setState({
                currentChartLabel: "Category Revenue (KES)",
                mostOrdered: sortedArray
            })
        })
    }

    getCurrentMonthHighestEarning = async (month) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuItem {
            constructor(item, qty, total) {
                this.item = item
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.item + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuItemConverter = {
            toFirestore : function(item) {
                return {
                    item: item.item,
                    qty: item.qty,
                    total: item.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuItem(data.item, data.qty, data.total)
            }
        }

        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(this.state.currentYear)
        .collection(month)
        .doc("allOrders")
        .collection("list")
        .withConverter(menuItemConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            sortedArray.map(item => {
                this.state.currentChartLabels.push(item.item)
                this.state.currentData.push(item.total)
            })
            // console.log(sortedArray)
            // const mostOrdered = sortedArray.slice(0, 10);
            this.setState({
                currentChartLabel: "Item Revenue (KES)",
                showRenderHighestEarningRevenue: true,
                highestEarning: sortedArray
            })
        })
    }

    getCurrentMonthHighestEarningCategory = async (month) => {
        this.setState({
            currentChartLabels: [],
            currentData: []
        })
        class MenuCategory {
            constructor(category, qty, total) {
                this.category = category
                this.qty = qty
                this.total = total
            }
            toString () {
                return this.category + ', ' +
                this.qty + ', ' +
                this.total
            }
        }
        var menuCategoryConverter = {
            toFirestore : function(category) {
                return {
                    category: category.category,
                    qty: category.qty,
                    total: category.total
                }
            },
            fromFirestore : function(snapshot, options) {
                const data = snapshot.data(options)
                return new MenuCategory(data.category, data.qty, data.total)
            }
        }
        fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("admin")
        .doc("transactions")
        .collection("orders")
        .doc(this.state.currentYear)
        .collection(month)
        .doc("allCategories")
        .collection("list")
        .withConverter(menuCategoryConverter)
        .get().then(snapshot => {
            const data = snapshot.docs.map(doc => doc.data())
            const sortedArray = data.sort((a, b) => b.total - a.total)
            sortedArray.map(category => {
                if (category.category === "coffee_and_tea") {
                    category.category = "Coffee and Tea"
                } else if (category.category === "iced_coffee_and_tea") {
                    category.category = "Iced Coffee and Tea"
                } else if (category.category === "breakfast") {
                    category.category = "Breakfast"
                } else if (category.category === "starters_and_sharing") {
                    category.category = "Starters and Sharing"
                } else if (category.category === "lunch_and_dinner") {
                    category.category = "Lunch and Dinner"
                } else if (category.category === "burgers") {
                    category.category = "Burgers"
                } else if (category.category === "chips") {
                    category.category = "Chips"
                } else if (category.category === "wings") {
                    category.category = "Wings"
                } else if (category.category === "sandwiches") {
                    category.category = "Sandwiches"
                } else if (category.category === "salads") {
                    category.category = "Salads"
                } else if (category.category === "art_pizzas") {
                    category.category = "Art Pizzas"
                } else if (category.category === "pasta") {
                    category.category = "Pasta"
                } else if (category.category === "bakery") {
                    category.category = "Bakery"
                } else if (category.category === "cakes_and_desserts") {
                    category.category = "Cakes and Desserts"
                } else if (category.category === "cold_press_juices") {
                    category.category = "Cold Press Juices"
                } else if (category.category === "soft_drinks") {
                    category.category = "Soft Drinks"
                } else if (category.category === "kids_menu") {
                    category.category = "Kids Menu"
                } else if (category.category === "whole_cakes") {
                    category.category = "Whole Cakes"
                } else if (category.category === "power_smoothies") {
                    category.category = "Power Smoothies"
                } else if (category.category === "steaks") {
                    category.category = "Steaks"
                } else if (category.category === "soup") {
                    category.category = "Soup"
                } else if (category.category === "mocktails") {
                    category.category = "Mocktails"
                } else if (category.category === "hot_n_boozy") {
                    category.category = "Hot N Boozy"
                } else if (category.category === "beer") {
                    category.category = "Beer"
                } else if (category.category === "white_wine") {
                    category.category = "White Wine"
                } else if (category.category === "sangria") {
                    category.category = "Sangria"
                } else if (category.category === "red_wine") {
                    category.category = "Red Wine"
                } else if (category.category === "sparkling") {
                    category.category = "Sparkling"
                } else if (category.category === "rose") {
                    category.category = "Rosé"
                } else if (category.category === "art_cocktails") {
                    category.category = "Art Cocktails"
                } else if (category.category === "cocktails") {
                    category.category = "Cocktails"
                } else if (category.category === "spirits_and_liquer") {
                    category.category = "Spirits and Liquer"
                } else if (category.category === "milkshakes") {
                    category.category = "Milkshakes"
                } else if (category.category === "quiches") {
                    category.category = "Quiches"
                }
                this.state.currentChartLabels.push(category.category)
                this.state.currentData.push(category.total)
            })
            this.setState({
                currentChartLabel: "Category Revenue (KES)",
                highestEarning: sortedArray
            })
        })
    }

        //* - - FOCUSED INSIGHTS DROPDOWN HANDLERS - - *//

    handleSelectGeneralRevenueOptions = (selectedOptions) => {
        if (this.state.showChartLoading === true) {
            this.handleScrollToGraph()
        } else {
            if (selectedOptions.value === "highest-spend") {
                if (this.state.currentMonth === "" || this.state.currentMonth === "full-year") {
                    this.getCurrentYearHighestSpendingCustomers(this.state.currentYear)
                    this.setState({
                        chartHeader: "Annual Revenue"
                    })
                } else {
                    this.getMonthlyChartData(this.state.currentMonth)
                    this.getCurrentMonthHighestSpendingCustomers(this.state.currentMonth)
                    this.setState({
                        chartHeader: "Monthly Revenue"
                    })
                }
                this.setState({
                    focusedInsightsSelectedHeader: "Highest Spending Customers:",
                    showDataDisplay: false,
                    showRenderHighestSpendingRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    showRenderHighestEarningRevenue: false,
                    showDataDisplayLoading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showDataDisplayLoading: false,
                            showDataDisplay: true,
                            showRenderHighestSpendingRevenue: true
                        })
                    }, 2000)
                })
            } else if (selectedOptions.value === "frequent-customers") {
                if (this.state.currentMonth === "" || this.state.currentMonth === "full-year") {
                    this.getCurrentYearMostFrequentCustomers(this.state.currentYear)
                    this.setState({
                        chartHeader: "Annual Revenue"
                    })
                } else {
                    this.getMonthlyChartData(this.state.currentMonth)
                    this.getCurrentMonthMostFrequentCustomers(this.state.currentMonth)
                    this.setState({
                        chartHeader: "Monthly Revenue"
                    })
                }
                this.setState({
                    focusedInsightsSelectedHeader: "Most Frequent Customers:",
                    showDataDisplay: false,
                    showRenderMostOrderedRevenue: false,
                    showRenderHighestEarningRevenue: false,
                    showRenderHighestSpendingRevenue: false,
                    showDataDisplayLoading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showDataDisplayLoading: false,
                            showDataDisplay: true,
                            showRenderHighestSpendingRevenue: true
                        })
                    }, 2000)
                })
            } else if (selectedOptions.value === "most-ordered") {
                if (this.state.currentMonth === "" || this.state.currentMonth === "full-year") {
                    this.getCurrentYearMostOrdered(this.state.currentYear)
                    this.setState({
                        chartHeader: "Annual Orders Revenue (by Most Ordered Items)"
                    })
                } else {
                    this.getCurrentMonthMostOrdered(this.state.currentMonth)
                    this.setState({
                        chartHeader: "Monthly Orders Revenue (by Most Ordered Items)"
                    })
                }
                this.setState({
                    focusedInsightsSelectedHeader: "Frequently Ordered Items:",
                    showDataDisplay: false,
                    showRenderHighestSpendingRevenue: false,
                    showRenderHighestEarningRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    showDataDisplayLoading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showDataDisplayLoading: false,
                            showDataDisplay: true,
                            showRenderMostOrderedRevenue: true
                        })
                    }, 2000)
                })
            } else if (selectedOptions.value === "highest-earning") {
                if (this.state.currentMonth === "" || this.state.currentMonth === "full-year") {
                    this.getCurrentYearHighestEarning(this.state.currentYear)
                    this.setState({
                        chartHeader: "Annual Orders Revenue (by Highest Earning Items)"
                    })
                } else {
                    this.getCurrentMonthHighestEarning(this.state.currentMonth)
                    this.setState({
                        chartHeader: "Monthly Orders Revenue (by Highest Earning Items)"
                    })
                }
                this.setState({
                    focusedInsightsSelectedHeader: "Highest Earning Items:",
                    showDataDisplay: false,
                    showRenderHighestEarningRevenue: false,
                    showRenderHighestSpendingRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    showDataDisplayLoading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showDataDisplayLoading: false,
                            showDataDisplay: true,
                            showRenderHighestEarningRevenue: true
                        })
                    }, 2000)
                })
            } else if (selectedOptions.value == "most-ordered-categories") {
                if (this.state.currentMonth === "" || this.state.currentMonth === "full-year") {
                    this.getCurrentYearMostOrderedCategory(this.state.currentYear)
                    this.setState({
                        chartHeader: "Annual Orders Revenue (by Most Ordered Categories)"
                    })
                } else {
                    this.getCurrentMonthMostOrderedCategory(this.state.currentMonth)
                    this.setState({
                        chartHeader: "Monthly Orders Revenue (by Most Ordered Categories)"
                    })
                }
                this.setState({
                    focusedInsightsSelectedHeader: "Most Ordered Categories:",
                    showDataDisplay: false,
                    showRenderHighestSpendingRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    showRenderHighestEarningRevenue: false,
                    showDataDisplayLoading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showDataDisplayLoading: false,
                            showDataDisplay: true,
                            showRenderMostOrderedRevenue: true
                        })
                    }, 2000)
                })
            } else if (selectedOptions.value == "highest-earning-categories") {
                if (this.state.currentMonth === "" || this.state.currentMonth === "full-year") {
                    this.getCurrentYearHighestEarningCategory(this.state.currentYear)
                    this.setState({
                        chartHeader: "Annual Orders Revenue (by Highest Earning Categories)"
                    })
                } else {
                    this.getCurrentMonthHighestEarningCategory(this.state.currentMonth)
                    this.setState({
                        chartHeader: "Monthly Orders Revenue (by Highest Earning Categories)"
                    })
                }
                this.setState({
                    focusedInsightsSelectedHeader: "Highest Earning Categories:",
                    showDataDisplay: false,
                    showRenderHighestSpendingRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    showRenderHighestEarningRevenue: false,
                    showDataDisplayLoading: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showDataDisplayLoading: false,
                            showDataDisplay: true,
                            showRenderHighestEarningRevenue: true
                        })
                    }, 2000)
                })
            }
        }
    }

    handleSelectMonthsOptions = (selectedOptions) => {
        if (this.state.focusedSelectedCategory === "Revenue") {
            //* - - ADD LOADER - - *//
            if (selectedOptions.value !== "full-year") {
                this.getMonthlyRevenueTotal(selectedOptions.value)
                this.getMonthlyChartData(selectedOptions.value)
                this.getCurrentMonthHighestSpendingCustomers(selectedOptions.value)
                this.setState({
                    chartHeader: "Monthly Revenue",
                    showCurrentRevenueTotal: false,
                    showDataDisplay: false,
                    showRenderHighestEarningRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    currentMonth: selectedOptions.value,
                    showDataDisplayLoading: true,
                    showCurrentRevenueLoading: true
                }, () => {
                    setTimeout(() => {
                       this.setState({
                        showCurrentRevenueLoading: false,
                        focusedPaneTimeframe: `${selectedOptions.label} Revenue `,
                        showDataDisplayLoading: false,
                        showDataDisplay: true,
                        showCurrentRevenueTotal: true
                       })
                    }, 2000)
                })
            } else {
                this.getCurrentYearTotalRevenue(this.state.currentYear)
                this.getCurrentYearHighestSpendingCustomers(this.state.currentYear)
                this.setState({
                    chartHeader: "Annual Revenue",
                    showCurrentRevenueTotal: false,
                    showDataDisplay: false,
                    currentMonth: selectedOptions.value,
                    showRenderHighestEarningRevenue: false,
                    showRenderMostOrderedRevenue: false,
                    showDataDisplayLoading: true,
                    showCurrentRevenueLoading: true
                }, () => {
                    setTimeout(() => {
                       this.setState({
                        showCurrentRevenueLoading: false,
                        focusedPaneTimeframe: `Annual Revenue `,
                        showDataDisplayLoading: false,
                        showRenderHighestSpendingRevenue: true,
                        showDataDisplay: true,
                        showCurrentRevenueTotal: true
                       })
                    }, 2000)
                })
            }
        }
    }

        //* - - RENDER DATA - - *//

    renderHighestSpending = () => {
        if (this.state.highestSpending.length !== 0) {
            return (this.state.highestSpending.map((users, index) => {
                var {id, name, qty, total} = users
                return (
                    <div style={{display: "flex", justifyContent: "space-between"}} className='dataDisplayCell'>
                        <p style={{marginTop: "0px", paddingTop: "2.5%", textAlign: "left", color: "#0930cb", fontFamily: "sora", marginLeft: "2%", marginBottom: "0px", fontSize: "90%"}}>{index + 1}. {name}  <label style={{color: "black", fontWeight: "bold"}}>({qty})</label></p>
                        <h4 style={{marginTop: "0px", paddingTop: "2.5%", marginRight: "2.5%", fontFamily: "sora", color: "#0930cb", marginBottom: "2.5%", fontSize: "90%"}}>KES {total}</h4>
                    </div>
                )
            }))
        } else {
            return (
                <div>
                    <h3 style={{fontFamily: "sora", color: "#0930cb", marginTop: "12.5%"}}>No data available</h3>
                </div>
            )
        }
    }

    renderMostOrdered = () => {
        if (this.state.mostOrdered.length !== 0) {
            return (this.state.mostOrdered.map((items, index) => {
                var {category, item, qty, total} = items
                return (
                    <div style={{display: "flex", justifyContent: "space-between"}} className='dataDisplayCell'>
                        <p style={{marginTop: "0px", paddingTop: "2.5%", textAlign: "left", color: "#0930cb", fontFamily: "sora", marginLeft: "2%", marginBottom: "0px", fontSize: "90%"}}>{index + 1}. {item ? item : category}  <label style={{color: "black", fontWeight: "bold"}}>({qty})</label></p>
                        <h4 style={{marginTop: "0px", paddingTop: "2.5%", marginRight: "2.5%", fontFamily: "sora", color: "#0930cb", marginBottom: "2.5%", fontSize: "90%"}}>KES {total}</h4>
                    </div>
                )
            }))
        } else {
            return (
                <div>
                    <h3 style={{fontFamily: "sora", color: "#0930cb", marginTop: "12.5%"}}>No data available</h3>
                </div>
            )
        }
    }

    renderHighestEarning = () => {
        if (this.state.highestEarning.length !== 0) {
            return (this.state.highestEarning.map((items, index) => {
                var {category, item, qty, total} = items
                return (
                    <div style={{display: "flex", justifyContent: "space-between"}} className='dataDisplayCell'>
                        <p style={{marginTop: "0px", paddingTop: "2.5%", textAlign: "left", color: "#0930cb", fontFamily: "sora", marginLeft: "2%", marginBottom: "0px", fontSize: "90%"}}>{index + 1}. {item ? item : category}  <label style={{color: "black", fontWeight: "bold"}}>({qty})</label></p>
                        <h4 style={{marginTop: "0px", paddingTop: "2.5%", marginRight: "2.5%", fontFamily: "sora", color: "#0930cb", marginBottom: "2.5%", fontSize: "90%"}}>KES {total}</h4>
                    </div>
                )
            }))
        } else {
            return (
                <div>
                    <h3 style={{fontFamily: "sora", color: "#0930cb", marginTop: "12.5%"}}>No data available</h3>
                </div>
            )
        }
    }

        //* - - OTHER FUNCTIONS - - *//

    generateMostOrderedPDF = () => {
        const { mostOrdered } = this.state;
    
        // Create a new jsPDF instance
        const pdf = new jsPDF();
    
        // Define columns for the table
        const columns = ['Item', 'Quantity', 'Total'];
    
        // Define rows from the mostOrdered array
        const rows = mostOrdered.map(order => [order.item, order.qty, order.total]);
    
        // Add a title to the PDF
        pdf.text('Most Ordered Items', 10, 10);
    
        // Generate a table using autoTable plugin
        pdf.autoTable({
            head: [columns],
            body: rows,
            startY: 20,
        });
    
        // Save the PDF
        pdf.save('most_ordered_items.pdf');
    };

    viewMoreInsightsClicked = () => {
        this.getTotalRevenue24Hours()
        this.getTotalTransactions24Hours()
        this.getNewMembers24Hours()
        this.setState({
            showViewMoreInsightsBtn: false,
            showFocusedInsights: false,
            showTopRightCardRevenue: false,
            showTopRightCardLoading: true,
            showInsightsLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showInsightsLoading: false,
                    showTopRightCardLoading: false,
                    showBackToAllInsights: true,
                    showTopRightCardMembers: true,
                    showQuickInsightsHeader1: true,
                    showMoreInsights: true
                })
            }, 2000)
        })
    }

    backToAllInsightsClicked = () => {
        this.getTotalRevenue24Hours()
        this.getTotalTransactions24Hours()
        this.getNewMembers24Hours()
        this.setState({
            showMoreInsights: false,
            showBackToAllInsights: false,
            showTopRightCardMembers: false,
            showQuickInsightsHeader1: false,
            showTopRightCardLoading: true,
            showInsightsLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showInsightsLoading: false,
                    showTopRightCardLoading: false,
                    showViewMoreInsightsBtn: true,
                    showTopRightCardRevenue: true,
                    showFocusedInsights: true
                })
            }, 2000)
        })
    }

    mostOrderedClicked = () => {
    }

    handleScrollToGraph = () => {
        setTimeout(() => {
            const element = document.getElementById('analyticsGraph');
            if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 500)
    }

    render () {

        const options = [
            { value: '1-day', label: 'Today' },
            // { value: '3-days', label: 'Last 3 days' },
            // { value: '5-days', label: 'Last 5 days' },
            { value: '7-days', label: 'Last 7 days' },
            { value: '30-days', label: 'This month' }
        ]

        const options2 = [
            { value: '1-day', label: 'Today' },
            { value: '7-days', label: 'Last 7 days' },
            { value: '1-month', label: 'This month' },
            { value: '3-months', label: 'Last 3 mo.' },
            { value: '6-months', label: 'Last 6 mo.' },
            { value: '1-year', label: 'This year' }
        ]

        const defaultValue = options[0]
        const defaultValue2 = options2[0]

        const chartData = {
            labels: this.state.currentChartLabels,
            datasets: [
            //   {
            //     label: 'Line Chart',
            //     data: [65, 59, 80, 81, 56, 55, 40],
            //     fill: false,
            //     borderColor: 'rgba(75,192,192,1)',
            //     tension: 0.1,
            //   },
              {
                label: this.state.currentChartLabel,
                data: this.state.currentData,
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
              },
            ],
          };

        const yearOptions = [
            {value: '2023', label: '2023'},
            {value: '2024', label: '2024'}
        ]

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        let yearOptionsDefaultValue 
        if (yearOptions[0].value === currentYear) {
           yearOptionsDefaultValue = yearOptions[0]
        } else {
            yearOptionsDefaultValue = yearOptions[1]
        }

        const revenueOptions = [
            {value: 'total', label: 'Total Revenue'},
            // {value: 'byCategory', label: 'By Menu Category'},
            // {value: 'byItem', label: 'By Menu Item'}
        ]

        const revenueOptionsDefaultValue = revenueOptions[0]
        

        const monthOptions = [
            {value: 'full-year', label: 'Full Year'},
            {value: 'jan', label: 'January'},
            {value: 'feb', label: 'February'},
            {value: 'mar', label: 'March'},
            {value: 'apr', label: 'April'},
            {value: 'may', label: 'May'},
            {value: 'jun', label: 'June'},
            {value: 'jul', label: 'July'},
            {value: 'aug', label: 'August'},
            {value: 'sep', label: 'September'},
            {value: 'oct', label: 'October'},
            {value: 'nov', label: 'November'},
            {value: 'dec', label: 'December'},
        ]
        
        let monthOptionsDefaultValue = monthOptions[0]
        // const currentMonth = (currentDate.getMonth() + 1).toString(); // Adding 1 because getMonth() returns a zero-based index

        // for (let i = 0; i < monthOptions.length; i++) {
        // if (currentMonth === monthOptions[i].value) {
        //     monthOptionsDefaultValue = monthOptions[i];
        //     break;
        // }
        // }

        const generalRevenueOptions = [
            {value: 'highest-spend', label: 'Highest Spending Customers'},
            {value: 'frequent-customers', label: 'Most Frequent Customers'},
            {value: 'most-ordered', label: 'Frequently Ordered Items'},
            {value: 'most-ordered-categories', label: 'Frequently Ordered Categories'},
            {value: 'highest-earning', label: 'Highest Earning Items'},
            {value: 'highest-earning-categories', label: 'Highest Earning Categories'},
        ]

        const generalRevenueOptionsDefaultValue = generalRevenueOptions[0]
        

        return (
            <Styles>
                <div className='fullAnalytics'>
                    <div style={{borderBottom: "1px solid #0930cb", width: "93.5%", paddingBottom: "1%", paddingTop: "1%"}}></div>
                    <div className='quickInsightsHeader' style={{display: "flex", justifyContent: "space-between"}}>
                        <h2 style={{fontFamily: "rubik", fontWeight: "bold", fontSize: "30px", marginBottom: "1.5%", marginTop: "1.5%"}}>Quick Insights</h2>
                        {this.state.showBackToAllInsights && 
                            <button onClick={this.backToAllInsightsClicked} style={{marginRight: "6.5%", height: "100%", marginTop: "1.25%"}}>Back</button>
                        }
                    </div>
                    {this.state.showQuickInsightsHeader1 && 
                        <h2 style={{fontFamily: "sora", color: "#0930cb", marginTop: "0px"}}>{this.state.quickInsightsHeader1}</h2>
                    }
                    <div style={{marginTop: "0px"}} className='topDashboard'>
                        <div className='topDashCol'>
                            <div className='topDashCard'>
                                <div className='dashImg'>
                                    <div className='imgContainer'>
                                        <img src='/assets/member2.png'/>
                                    </div>
                                </div>
                                <div className='dashLabel'>
                                    <h2>Total Members</h2>
                                </div>
                                <div className='dashboardFigure'>
                                    <h1>{this.state.totalMembers}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='topDashCol'>
                            <div className='topDashCard'>
                                <div className='dashImg'>
                                    <div className='imgContainer'>
                                        <img src='/assets/plans.png'/>
                                    </div>
                                </div>
                                <div className='dashLabel'>
                                    <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Active Members</h2>
                                    <Select 
                                    defaultValue={defaultValue}
                                    onChange={this.handleActiveMembersChanged}
                                    className='selectMenu2' 
                                    options={options}/>
                                </div>
                                {this.state.showActiveMembersFigure && 
                                    <div className='dashboardFigure'>
                                        <h1>{this.state.activeMembers}</h1>
                                    </div>
                                }
                                {this.state.showActiveMembersFigureLoading && 
                                    <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                        <ClipLoader
                                        color="#0930cb"
                                        loading={true}
                                        // cssOverride={override}
                                        size={30}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className='topDashCol'>
                            <div className='topDashCard'>
                                {this.state.showTopRightCardLoading && 
                                    <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                        <ClipLoader
                                        color="#0930cb"
                                        loading={true}
                                        // cssOverride={override}
                                        size={30}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                        />
                                    </div>
                                }
                                {this.state.showTopRightCardRevenue && 
                                    <div>
                                        <div className='dashImg'>
                                            <div className='imgContainer'>
                                                <img style={{width: "50%", padding: "23%"}} src='/assets/revenue.png'/>
                                            </div>
                                        </div>
                                        <div className='dashLabel'>
                                            <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Total Revenue</h2>
                                            <Select 
                                            defaultValue={defaultValue2}
                                            onChange={this.handleTotalRevenueChanged}
                                            className='selectMenu2' 
                                            options={options2}/>
                                        </div>
                                        {this.state.showTotalRevenueFigure && 
                                            <div className='dashboardFigure'>
                                                <h1>KES {this.state.totalRevenue}</h1>
                                            </div>
                                        }
                                        {this.state.showTotalRevenueFigureLoading && 
                                            <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                                <ClipLoader
                                                color="#0930cb"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                                {this.state.showTopRightCardMembers && 
                                    <div>
                                        <div className='dashImg'>
                                            <div className='imgContainer'>
                                                <img style={{width: "50%", padding: "23%"}} src='/assets/newMembersAnalytics.png'/>
                                            </div>
                                        </div>
                                        <div className='dashLabel'>
                                            <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>New Members</h2>
                                            <Select 
                                            defaultValue={defaultValue2}
                                            onChange={this.handleNewMembersChanged}
                                            className='selectMenu2' 
                                            options={options}/>
                                        </div>
                                        {this.state.showNewMembersFigure && 
                                            <div className='dashboardFigure'>
                                                <h1>{this.state.newMembers}</h1>
                                            </div>
                                        }
                                        {this.state.showNewMembersFigureLoading && 
                                            <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                                <ClipLoader
                                                color="#0930cb"
                                                loading={true}
                                                // cssOverride={override}
                                                size={30}
                                                aria-label="Loading Spinner"
                                                data-testid="loader"
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className=''>
                        {this.state.showViewMoreInsightsBtn && <h5 style={{fontFamily: "sora", marginTop: "14%", marginBottom: "1%", textAlign: "right", marginRight: "6.5%"}}><label onClick={this.viewMoreInsightsClicked} className='viewMoreInsightsBtn'>view more quick insights</label></h5>}
                        {this.state.showMoreInsights && 
                            <div style={{paddingBottom: "5%"}}>
                                <div style={{marginTop: "17.5%", borderBottom: "1.5px solid #0930cb", marginRight: "6.5%"}}></div>
                                <h2 style={{fontFamily: "sora", color: "#0930cb", marginTop: "2.5%"}}>{this.state.quickInsightsHeader2}</h2>
                                <div style={{marginTop: "1.5%"}} className='topDashboard'>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/revenue.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Total Revenue</h2>
                                                <Select 
                                                defaultValue={defaultValue2}
                                                onChange={this.handleTotalRevenueChanged}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            {this.state.showTotalRevenueFigure && 
                                                <div className='dashboardFigure'>
                                                    <h1>KES {this.state.totalRevenue}</h1>
                                                </div>
                                            }
                                            {this.state.showTotalRevenueFigureLoading && 
                                                <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                                    <ClipLoader
                                                    color="#0930cb"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={30}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img style={{width: "50%", padding: "23%"}} src='/assets/foodAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{fontSize: "110%", marginBottom: "1.5%"}}>No. of Items Bought</h2>
                                                <Select 
                                                defaultValue={defaultValue}
                                                onChange={this.handleTotalTransactionsChanged}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            {this.state.showTotalTransactionsFigure && 
                                                <div className='dashboardFigure'>
                                                    <h1>{this.state.totalTransactions}</h1>
                                                </div>
                                            }
                                            {this.state.showTotalTransactionsFigureLoading && 
                                                <div style={{paddingTop: "20.5%", marginTop: "2.75%"}}>
                                                    <ClipLoader
                                                    color="#0930cb"
                                                    loading={true}
                                                    // cssOverride={override}
                                                    size={30}
                                                    aria-label="Loading Spinner"
                                                    data-testid="loader"
                                                    />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/transactionsNoAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>No. of Transactions</h2>
                                                <Select 
                                                defaultValue={defaultValue2}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>KES 100000000</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{marginTop: "17.5%", borderBottom: "1.5px solid #0930cb", marginRight: "6.5%"}}></div>
                                <h2 style={{fontFamily: "sora", color: "#0930cb"}}>{this.state.quickInsightsHeader3}</h2>
                                <div style={{marginTop: "1.5%"}} className='topDashboard'>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/pointsAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Points Earned</h2>
                                                <Select 
                                                defaultValue={defaultValue2}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>KES 100000000</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/pointsUsedAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Used Points</h2>
                                                <Select 
                                                defaultValue={defaultValue}
                                                className='selectMenu2' 
                                                options={options}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>3</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/expiredPointsAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Expired Points</h2>
                                                <Select 
                                                defaultValue={defaultValue2}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>KES 100000000</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{marginTop: "17.5%", borderBottom: "1.5px solid #0930cb", marginRight: "6.5%"}}></div>
                                <h2 style={{fontFamily: "sora", color: "#0930cb"}}>{this.state.quickInsightsHeader4}</h2>
                                <div style={{marginTop: "1.5%"}} className='topDashboard'>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/rewardCostAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{fontSize: "108%", marginBottom: "1.5%"}}>Redeemed Rewards (A) Value</h2>
                                                <Select 
                                                defaultValue={defaultValue2}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>KES 100000000</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/redeemedRewardsAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{fontSize: "108%", marginBottom: "1.5%"}}>Redeemed Rewards (F) Value</h2>
                                                <Select 
                                                defaultValue={defaultValue}
                                                className='selectMenu2' 
                                                options={options}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>3</h1>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='topDashCol'>
                                        <div className='topDashCard'>
                                            <div className='dashImg'>
                                                <div className='imgContainer'>
                                                    <img src='/assets/frequentlyRedeemedAnalytics.png'/>
                                                </div>
                                            </div>
                                            <div className='dashLabel'>
                                                <h2 className='activeMemberStyle' style={{marginBottom: "1.5%"}}>Most Redeemed</h2>
                                                <Select 
                                                defaultValue={defaultValue2}
                                                className='selectMenu2' 
                                                options={options2}/>
                                            </div>
                                            <div className='dashboardFigure'>
                                                <h1>KES 100000000</h1>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {this.state.showFocusedInsights && 
                        <div className=''>
                            <div style={{borderBottom: "1px solid #0930cb", width: "93.5%", paddingBottom: "1%"}}></div>
                            <h2 style={{fontFamily: "rubik", fontWeight: "bold", marginTop: "1.5%", fontSize: "30px", marginBottom: "0.5%"}}>Focused Insights</h2>
                            <div style={{marginTop: "1%"}} className=''>
                                <h3 style={{fontFamily: "sora", color: "#0930cb", marginBottom: "0.5%"}}>Select a year / month</h3>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                {/* <Select 
                                className='analyticsOptionsMenu'
                                defaultValue={analyticsOptionsDefaultValue}
                                placeholder="Select a time period"
                                onChange={this.handleSelectAnalyticsOptions}
                                options={analyticsOptions}/> */}
                                <Select 
                                className='yearOptionsMenu'
                                defaultValue={yearOptionsDefaultValue}
                                placeholder="Select a time period"
                                onChange={this.handleSelectAnalyticsOptions}
                                options={yearOptions}/>
                                <Select 
                                className='yearOptionsMenu'
                                defaultValue={monthOptionsDefaultValue}
                                placeholder="Month"
                                onChange={this.handleSelectMonthsOptions}
                                options={monthOptions}/>
                                </div>
                            </div>
                            <div className='analyticsSelectionOptions'>
                                    <Dialog
                                    visible={this.state.showImgSelected}
                                    onClose={this.closeImgSelected}
                                    title="Item"
                                    >
                                        {/* <div style={renderSelectedImgContainer}>
                                            <img style={selectedImgStyle} src={this.state.currentImg}/>
                                        </div> */}
                                    </Dialog>
                                {/* <h2 style={{fontFamily: "sora", color: "#0930cb", marginBottom: "1%"}}>Insights</h2> */}
                                {this.state.showRevenueBtns && 
                                    <div>
                                        <div style={{display: "flex", justifyContent: "space-between", marginBottom: "2%"}}>
                                            {/* <Select 
                                            className='yearOptionsMenu'
                                            defaultValue={revenueOptionsDefaultValue}
                                            placeholder="Select..."
                                            onChange={this.handleSelectRevenueOptions}
                                            options={revenueOptions}/> */}
                                        </div>  
                                        <div className='revenueContainer'>
                                            <div className='revenueCol1'>
                                                {this.state.showCurrentRevenueTotal && 
                                                    <div>
                                                        <p style={{textAlign: "left", marginLeft: "4.5%", color: "white", fontFamily: "sora", marginBottom: "1%", fontWeight: "bold"}}>{this.state.focusedPaneTimeframe}</p>
                                                        <h1 style={{color: "white", marginTop: "1%", marginLeft: "3.5%", fontFamily: "sora", fontSize: "200%"}}>KES {this.state.currentRevenueTotal}</h1>
                                                        <Select 
                                                        className='generalOptionsMenu'
                                                        defaultValue={generalRevenueOptionsDefaultValue}
                                                        placeholder="Select..."
                                                        onChange={this.handleSelectGeneralRevenueOptions}
                                                        options={generalRevenueOptions}/>
                                                    </div>
                                                }
                                                {this.state.showCurrentRevenueLoading && 
                                                    <div style={{marginTop: "29.5%"}} className='currentRevenueLoading'>
                                                        <ClipLoader
                                                        color="#fff"
                                                        loading={true}
                                                        // cssOverride={override}
                                                        size={30}
                                                        aria-label="Loading Spinner"
                                                        data-testid="loader"
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            <div className='revenueCol2'>
                                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                                    <h4 style={{textAlign: "left", marginLeft: "0px", marginTop: "1.5%", color: "#fff", fontFamily: "sora", marginBottom: "0px"}}>{this.state.focusedInsightsSelectedHeader}</h4>
                                                    {/* <button
                                                    onClick={this.generateMostOrderedPDF}
                                                    >Generate Most Ordered PDF</button> */}
                                                </div>
                                                {this.state.showDataDisplay && 
                                                    <div className='dataDisplay'>
                                                        {this.state.showRenderHighestSpendingRevenue && 
                                                            <div>
                                                                {this.renderHighestSpending()}
                                                            </div>
                                                        }
                                                        {this.state.showRenderMostOrderedRevenue && 
                                                            <div>
                                                                {this.renderMostOrdered()}
                                                            </div>
                                                        }
                                                        {this.state.showRenderHighestEarningRevenue && 
                                                            <div>
                                                                {this.renderHighestEarning()}
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                {this.state.showDataDisplayLoading && 
                                                    <div className='dataDisplay'>
                                                        <div className='dataDisplayLoading'>
                                                            <ClipLoader
                                                            color="#0930cb"
                                                            loading={true}
                                                            // cssOverride={override}
                                                            size={30}
                                                            aria-label="Loading Spinner"
                                                            data-testid="loader"
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            {/* <div className='revenueCol3'>
                                                
                                            </div>
                                            <div className='revenueCol4'>
                                                
                                            </div> */}
                                        </div>  
                                    </div>
                                }
                            </div>
                            <div id='analyticsGraph' className='analyticsGraph'>
                                {this.state.showChartHeader && 
                                    <div>
                                        <h3 style={{fontFamily: "sora", marginTop: "1.5%", marginBottom: "1.5%", color: "#0930cb"}}>{this.state.chartHeader}</h3>
                                    </div>
                                }
                                {this.state.showChart && 
                                    <Line data={chartData} options={{ maintainAspectRatio: false }} />
                                }
                                {this.state.showChartLoading && 
                                    <div style={{textAlign: "center", marginTop: "20%"}}>
                                        <ClipLoader
                                        color="#0930cb"
                                        loading={true}
                                        // cssOverride={override}
                                        size={50}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                        />
                                    </div>
                                }
                            </div>
                            <div className=''>
                                <div className=''>
                                    {/* <Select 
                                    className='yearOptionsMenu'
                                    defaultValue={yearOptionsDefaultValue}
                                    placeholder="Select a time period"
                                    onChange={this.handleSelectAnalyticsOptions}
                                    options={yearOptions}/> */}
                                </div>
                                <div className=''>

                                </div>
                            </div>
                        </div>
                    }
                    {this.state.showInsightsLoading && 
                        <div style={{marginTop: "25.5%"}} className='analyticsLoading'>
                            <ClipLoader
                            color="#0930cb"
                            loading={true}
                            // cssOverride={override}
                            size={30}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}